export default __webpack_public_path__ + "static/media/road_img_9_1.c01f5823.jpg";